import api, { TOKEN_KEY } from "./client";
import { AuthResponse, User } from "../types";

export const signUp = (email: string, password: string) => {
  return api.post<AuthResponse>("/auth/signup", { email, password });
};

export const signIn = (email: string, password: string) => {
  return api.post<AuthResponse>("/auth/login", { email, password });
};

export const getMe = () => {
  return api.get<{ user: User }>("/auth/me");
};

export const setAuthToken = (token: string | null) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};

export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);
